
const { kebabCase } = require('lodash')

// Returns imports and angular code as parts of an array
module.exports = (name, fromScratch) => [
`${
    fromScratch ?
    `\n\n// React imports\nimport { react2angular } from 'libraries/react2angular'\n`: ``
}import ${name} from './components/${name}'`,
`${
    fromScratch ?
    `angular\n\t.module('root')\n`: ``
}\t.component('react${name}', react2angular(${name}, []))\n`]



// WEBPACK FOOTER //
// ./src/templates/react_2_angular.js